import { CardBody, Card, CardTitle } from 'reactstrap'

const NotActiveApplications = ({ adi, id, getData }) => {
  return (
    <Card
      style={{
        backgroundColor: '#efefef',
        marginTop: '0.5rem',
        marginLeft: '1rem',
        marginRight: '1rem',
        border: 'none',
      }}
    >
      <CardBody
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxHeight: '45px',
          paddingTop: '1.5rem',
        }}
      >
        <CardTitle
          style={{
            fontSize: '15px',
            marginLeft: '-8px',
            fontWeight: 'normal',
          }}
        >
          {adi}
        </CardTitle>
      </CardBody>
    </Card>
  )
}

export default NotActiveApplications
